import  FetchData, { } from '../../client';
import {getBranchId, getHospitalId, getLoginID, getToken}  from '../../../auth';
import formapimodalprescriptions from '../../domains/prescriptions/prescriptions';
import formapimodalprescriptionsPagination from '../../domains/prescriptions';
import axios from 'axios';
import { CONFIG } from '../../../appconfig/appconfig';
import formapimodalfollowupsPagination from '../../domains/followups';
import formapimodalfollowups from '../../domains/followups/followups';

  const FetchPrescriptionViewDetails = async (inputData) => {
    try {
      inputData.doctorid = getLoginID();
      inputData.branchid = getBranchId();
      inputData.hospitalid = getHospitalId()
      const result = await FetchData("midoc_getdoctorprescription", inputData);
      // console.log(result, "Prescription View Result")
      if (result.output) {
        var finalOutput = formapimodalprescriptionsPagination(result.output)
        }

        //console.log(finalOutput, "finalOUTPUT")
      return finalOutput;
  
    } catch (error) {
      console.error('Error fetching data in forms.js:', error);
      throw error;
    }
  };

  const FetchFilteredPrescriptionsList = async (inputData) => {
    try{
        // inputData.loginid = getLoginID();
        inputData.branchid = getBranchId();
        inputData.hospitalid = getHospitalId()
        const result = await FetchData('midoc_getdoctorprescription', inputData);
        // console.log(result, "Filtered Prescriptions View Result");

        if(result.output.data){
            var data = formapimodalprescriptions(result.output.data);

            let count = result?.output?.count;
            let pageno = result?.output?.pageno;
            let pagesize = result?.output?.pagesize;
            var finalOutput = {
                data,
                count,
                pageno,
                pagesize
            }
            // console.log(finalOutput, "final OUtuput");
            return finalOutput;
        }

    } catch(error) {
        console.error('Error fetching data in forms.js:', error);
        throw error;
    }
}

export async function GetOrderList(inputData){
  try {
    inputData.branchid = getBranchId();
    inputData.hospitalid = getHospitalId();
    const result = await FetchData("midoc_getlaborderbydoctor", inputData)
    return result.output;

  } catch(error){
    console.error('Error fetching data in fGetOrderList:', error);
    throw error;
  }
}

export async function GetOrderVaccinationList(inputData){
  try {
    inputData.branchid = getBranchId();
    inputData.hospitalid = getHospitalId();
    const result = await FetchData("midoc_getfollowupvaccination", inputData)
    return result.output;

  } catch(error){
    console.error('Error fetching data in fGetOrderList:', error);
    throw error;
  }
}

export async function GetImagingList(inputData){
  try {
    inputData.branchid = getBranchId();
    inputData.hospitalid = getHospitalId();
    const result = await FetchData("midoc_getimagingorderbydoctor", inputData)
    return result.output;
  } catch(error){
    console.error('Error fetching data in GetImagingList:', error);
    throw error;
  }
}
export async function GetProceduresList(inputData){
  try {
    inputData.branchid = getBranchId();
    inputData.hospitalid = getHospitalId();
    const result = await FetchData("midoc_getprocedureorderbydoctor", inputData)
    return result.output;
  } catch(error){
    console.error('Error fetching data in GetProceduresList:', error);
    throw error;
  }
}

export async function GetFollowupsList(inputData){
  try {
    inputData.branchid = getBranchId();
    inputData.hospitalid = getHospitalId();
    const result = await FetchData("midoc_getfollowuplist", inputData)
    console.log('result services: ', result)

    if (result.output) {
      var finalOutput = formapimodalfollowupsPagination(result.output)
      }

      //console.log(finalOutput, "finalOUTPUT")
    return finalOutput;

    // return result.output;
  } catch(error){
    console.error('Error fetching data in GetFollowupsList:', error);
    throw error;
  }
}

export const FetchFilteredFollowupsList = async (inputData) => {
  try{
      // inputData.loginid = getLoginID();
      inputData.branchid = getBranchId();
      inputData.hospitalid = getHospitalId()
      const result = await FetchData('midoc_getfollowuplist', inputData);
      // console.log(result, "Filtered Prescriptions View Result");

      if(result.output.data){
          var data = formapimodalfollowups(result.output.data);

          let count = result?.output?.count;
          let pageno = result?.output?.pageno;
          let pagesize = result?.output?.pagesize;
          var finalOutput = {
              data,
              count,
              pageno,
              pagesize
          }
          // console.log(finalOutput, "final OUtuput");
          return finalOutput;
      }

  } catch(error) {
      console.error('Error fetching data in forms.js:', error);
      throw error;
  }
}


export async function saveNotification(inputData){
  try {
    inputData.branchid = getBranchId();
    inputData.hospitalid = getHospitalId();
    const result = await FetchData("midoc_doctorprocedurenotification", inputData)
    return result
  } catch(error){
    console.error('Error fetching data in GetProceduresList:', error);
    throw error;
  }
}

export async function FetchLogsData(inputData){
  try {
    inputData.branchid = getBranchId();
    inputData.hospitalid = getHospitalId();
    const result = await FetchData("midoc_getorderlog", inputData)
    return result
  } catch(error){
    console.error('Error fetching data in GetProceduresList:', error);
    throw error;
  }
}
export async function DischargeSummaryLogs(inputData){
  try {
    inputData.branchid = getBranchId();
    inputData.hospitalid = getHospitalId();
    const result = await FetchData("midoc_getdischargesummarylog", inputData)
    return result
  } catch(error){
    console.error('Error fetching data in DischargeSummaryLogs:', error);
    throw error;
  }
}

// export const FetchCategories = async (inputData) => {
//   try {
//     inputData.doctorid = getLoginID();

//     inputData.branchid = getBranchId();
//     inputData.hospitalid = getHospitalId();
//     // const result = await FetchData("midoc_ai_recommendedprocedure", inputData);
//     const result = await FetchData("midoc_ai_notificationcategories", inputData);
//     // const result = await FetchData("midoc_ai_describenotification", inputData);
//     console.log('services result: ', result)
//     return result;

//   } catch (error) {
//     console.error('Error fetching data in forms.js:', error);
//     throw error;
//   }
// };

 export const getProcedureCategoryData = async (inputData) => {
  try {
    inputData.doctorid = getLoginID();
    inputData.branchid = getBranchId();
    inputData.hospitalid = getHospitalId()
    const token = getToken();
    const headers = {
      'Content-Type': 'application/json',
    };
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    const response = await axios.post(`${CONFIG.APIBaseUrl}midoc_ai_generatenotification`, 
      inputData,
    {
      headers: headers,
    });
    
    return response.data;

  } catch (error) {
    console.error('Error fetching data in forms.js:', error);
    throw error;
  }
};


 export const FetchCategories = async (inputData) => {
  try {
    inputData.doctorid = getLoginID();
    // inputData.branchid = getBranchId();
    // inputData.hospitalid = getHospitalId()
    const token = getToken();
    const headers = {
      'Content-Type': 'application/json',
    };
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    const response = await axios.post(`${CONFIG.APIBaseUrl}midoc_ai_notificationcategories`, 
      inputData,
    {
      headers: headers,
    });
    
    return response.data;

  } catch (error) {
    console.error('Error fetching data in forms.js:', error);
    throw error;
  }
};

export async function saveLabNotification(inputData){
  try {
    inputData.branchid = getBranchId();
    inputData.hospitalid = getHospitalId();
    const result = await FetchData("midoc_doctorlabsnotificationreminder", inputData)
    return result
  } catch(error){
    console.error('Error fetching data in GetLabsList:', error);
    throw error;
  }
}
export async function saveImagingNotification(inputData){
  try {
    inputData.branchid = getBranchId();
    inputData.hospitalid = getHospitalId();
    const result = await FetchData("midoc_doctorimagingnotificationreminder", inputData)
    return result
  } catch(error){
    console.error('Error fetching data in GetImagingsList:', error);
    throw error;
  }
}
export async function saveProcedureNotification(inputData){
  try {
    inputData.branchid = getBranchId();
    inputData.hospitalid = getHospitalId();
    const result = await FetchData("midoc_doctorprocedurenotificationreminder", inputData)
    return result
  } catch(error){
    console.error('Error fetching data in GetProceduresList:', error);
    throw error;
  }
}
export async function saveVaccinationNotification(inputData){
  try {
    inputData.branchid = getBranchId();
    inputData.hospitalid = getHospitalId();
    const result = await FetchData("midoc_doctorvaccinenotificationreminder", inputData)
    return result
  } catch(error){
    console.error('Error fetching data in GetVaccinesList:', error);
    throw error;
  }
}

// Appoinment Status call
export const documentProcessingStatus = async (inputData) => {
  try {
    inputData.doctorid = getLoginID();
    inputData.branchid = getBranchId();
    inputData.hospitalid = getHospitalId()
    const result = await FetchData("midoc_updateorderstatus", inputData);
    // console.log(result, 'api DAtaa')
    return result;

  } catch (error) {
    console.error('Error updating profile:', error); 
    throw error;
  }
};

// Book Appointment Call
export const BookAppointment = async (inputData) => {
  try {
    inputData.doctorid = getLoginID();
    inputData.branchid = getBranchId();
    inputData.hospitalid = getHospitalId()
    const result = await FetchData("midoc_addappointmentorder", inputData);
    // console.log(result, 'api DAtaa')
    return result;

  } catch (error) {
    console.error('Error updating profile:', error); 
    throw error;
  }
};

export async function SubmitLabReport(inputData){
  try {
    inputData.branchid = getBranchId();
    inputData.hospitalid = getHospitalId();
    const result = await FetchData("midoc_generatelabreportbyapi", inputData)
    // console.log('result services: ', result)

    // if (result.output) {
    //   var finalOutput = formapimodalfollowupsPagination(result.output)
    //   }

      //console.log(finalOutput, "finalOUTPUT")
    return result;

    // return result.output;
  } catch(error){
    console.error('Error fetching data in GetFollowupsList:', error);
    throw error;
  }
}

export {FetchPrescriptionViewDetails, FetchFilteredPrescriptionsList};
